module.exports = __webpack_public_path__ + "img/artists-carrousel-3.0ee74e9b.png";